"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _scss = require("@scss");

var _Input = _interopRequireDefault(require("@components/Form/Input"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _excluded = ["classes", "laterContent", "eraserContent", "onClear"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InputEraser = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {
    element: '',
    eraser: ''
  } : _ref$classes,
      laterContent = _ref.laterContent,
      eraserContent = _ref.eraserContent,
      onClear = _ref.onClear,
      props = _objectWithoutProperties(_ref, _excluded);

  var inputRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(props.value || props.defaultValue ? true : false),
      _useState2 = _slicedToArray(_useState, 2),
      inputFilled = _useState2[0],
      setInputFilled = _useState2[1];

  var onClickClear = (0, _react.useCallback)(function (ev) {
    if (_typeof(ref) === 'object' && ref !== null && ref !== void 0 && ref.current) {
      ref.current.value = '';
    }

    if (inputRef !== null && inputRef !== void 0 && inputRef.current) {
      inputRef.current.value = '';
    }

    setInputFilled(false);

    if (onClear) {
      onClear();
    }
  }, [ref, inputRef, setInputFilled, onClear]);
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
    ref: ref ? ref : inputRef
  }, props, {
    onChange: function onChange(e) {
      setInputFilled(!!e.target.value);

      if (props.onChange) {
        props.onChange(e);
      }
    },
    classes: {
      element: (0, _scss.cls)(_stylesModule["default"].input, classes['element'], props.size === 'sm' && _stylesModule["default"].inputSmall)
    },
    "data-filled": inputFilled,
    laterContent: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, laterContent ? laterContent : '', /*#__PURE__*/_react["default"].createElement("button", {
      onClick: onClickClear,
      type: "button",
      className: (0, _scss.cls)(_stylesModule["default"].eraser, props.size === 'sm' && _stylesModule["default"].eraserSmall, !inputFilled && _stylesModule["default"].hiddenEraser, classes['eraser'])
    }, eraserContent))
  }));
});
var _default = InputEraser;
exports["default"] = _default;